/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 */
import { Record } from 'immutable'

const _AccommodationInvoiceDetailState = {
  id: null,
  accommodation_invoice_id: null,
  title: '',
  unit_price: null,
  quantity: null,
  total: null,
  invoice_type: ''
}

class AccommodationInvoiceDetailState extends Record(_AccommodationInvoiceDetailState) {
  getInvoiceTypeLabel() {
    switch (this.invoice_type) {
      case 'accommodation_fee':
        return '宿泊費'
      case 'accommodation_tax':
        return '宿泊税'
      default:
        return 'その他'
    }
  }
}

export { AccommodationInvoiceDetailState }
